import { getEscapedRoles } from '@/utils/i18n-escape'

export default {
  title: 'Best Cases',
  roles: getEscapedRoles([
    {
      name: 'Market',
      objectives: [
        {
          content: 'Maintain the leading edge of XX game brand, enhance market awareness and influence',
          keyResults: [
            'Brand strategy: redefine the XX game brand, express the brand concept in a differentiated manner, implement the brand strategy in a special form, and produce 10 propaganda materials, with a total exposure of 100 million',
            'Promo: Complete 1 mixed cut out of the street video in the first month, and complete the video shooting of XX new game brand before the end of the Q3 cycle@Lisa',
            'Channel cooperation: Co-create top-level IP cooperation and attract 10 brand accounts with more than 1 million fans on XX stations to settle in'
          ]
        },
        {
          content: 'Accumulate creative experience and brand management methodology, and output the support capabilities of the middle office',
          keyResults: [
            'Complete the construction of the material center system, and at least 1,000 creative materials will be formed in the Q3 cycle',
            'Form a set of high-quality material writing methodology, improve the efficiency and quality of the overall staff writing materials, and shorten the material writing cycle by at least 30%'
          ]
        },
        {
          content: 'Increase the number of active fans and players through online drainage activities on new social media',
          keyResults: [
            'Write at least 10 high-quality tweets every week, with a reading volume of no less than 100,000, and the number of new fans and players in the cycle is 50,000@Lisa',
            'Carry out at least 10 online forwarding activities with prizes, and the average number of forwarding in a single game is not less than 10,000, and the proportion of fans and players participating in the activities is not less than 30%@Jack',
            'Analyze the tweet data and adjust the writing method according to the results. The average reading volume in the second half of the month increased by 10% compared with the first half of the month@Lily\n'
          ]
        }
      ]
    },
    {
      name: 'Product',
      objectives: [
        {
          content: 'Enter the XX track and complete the first generation product design',
          keyResults: [
            'Refine the core needs of players by investigating the circle of players, and output relevant statistical results',
            'According to the research results, determine the research and development direction of product XX, and output the product plan, which is recognized by the review committee',
            'Carry out grayscale testing and optimize the product, and improve the test user satisfaction to 90% within the cycle@Lisa@Lily'
          ]
        },
        {
          content: 'Complete product basic ability optimization and improve player satisfaction',
          keyResults: [
            'Adjust the XX system, optimize XX capabilities, and increase user satisfaction from 80% to 90%@Lily',
            'Introduce the XX system, strengthen the product XX capabilities, and get through the data with the business team XX@Jack',
            'Complete the scheduling of product requirements, clarify the implementation sequence of all current requirements, and ensure that P0 requirements are completed on schedule'
          ]
        },
        {
          content: 'Optimize the key functions and experience of XX products to fully meet commercial requirements',
          keyResults: [
            'Complete the XX function before X month X and meet the shelves standard of XX application store@Lisa',
            'Before this OKR cycle, open the account of Y product, support registration-free login, and registration-free users accounted for 20%',
            'Complete the A/B test of 2 key functions within 1 month of launch, increasing the average page retention rate to 20%'
          ]
        }
      ]
    },
    {
      name: 'R&D',
      objectives: [
        {
          content: 'Provide efficient and stable system support for XX business',
          keyResults: [
            'Optimize the XX algorithm to shorten the response time of the system to customer needs to 0.1 seconds, while maintaining the bug rate unchanged@succi',
            'The XX scheme has been implemented smoothly, the bug rate is controlled within 3%, and the system has no major accidents@Lily',
            'Create a new XX evaluation plan and XX model to achieve quantifiable statistical analysis of system stability'
          ]
        },
        {
          content: 'Create a complete enterprise data center to realize the accumulation and traceability of all product data',
          keyResults: [
            'After the completion of the data center frame design and program design, the senior management and business end unanimously passed',
            'Completed the model building of the first generation version of the data center, the stability remained above 99.9%, no major accidents',
            'After the first version is reached, the data of all links of the main business can be 100% traceable and statistical'
          ]
        }
      ]
    },
    {
      name: 'Finance',
      objectives: [
        {
          content: 'Establish a standardized budget management system and improve budget monitoring capabilities',
          keyResults: [
            'Complete the organization of the company’s overall budget items, clarify the mapping relationship between budget items and accounting items, and build a complete and clear pre-realistic comparison and analysis system (for example: clarify analysis cycles, dimensions, etc.)@simon',
            'The new version of the financial daily report is online, the display subjects and dimensions need to be further refined (according to the agreed standards of the XX meeting), and the data update cycle is shortened to T+8 hours@raphael',
            'The budget monitoring function is online, the coverage rate of each department reaches 100%, and the monthly average number of early warnings is not less than 6@Lily'
          ]
        },
        {
          content: 'Set up a financial shared service center to achieve cost reduction, efficiency increase, and transformation of the financial team',
          keyResults: [
            'Introduce consulting companies and technology companies, design financial sharing service plans and platforms, in the plan, it is necessary to clarify the personnel cost savings and the degree of improvement in operating efficiency@lando',
            'Implement the financial sharing service plan, complete the centralized management of financial personnel, and cover at least 80% of the subsidiaries of the group',
            'Complete the functional and professional division of SSC personnel, with an efficiency improvement ratio of not less than 50% (total working hours statistics), and the release and business transformation of local financial personnel, with the release and transformation ratio not less than 35%'
          ]
        }
      ]
    }
  ])
}
